/**
 *
 * 亚厦股份
 *
 */

import { getUrlParam } from '@/utils/api';
import { isBuild } from '@/utils/const';

const comein_channel = 'ylgf';

export const isThirdParty = getUrlParam().comein_channel === comein_channel;

console.log('isThirdParty', isThirdParty);

function Bridge() {
	this.title = '伊利股份';

	this.comein_channel = comein_channel;

	this.authMethod = 1;

	this.menuType = 'tab';
	this.menuTabList = [
		{
			title: '首页',
			path: '/mobile/flagship/index?id=' + (isBuild ? 20902 : 314) + '&comein_channel=ylgf',
			icon: '#icon-tab_home',
			active_icon: '#icon-tab_home_pre'
		},
		{
			title: '我',
			path: '/mobile/institute/user?comein_channel=ylgf',
			icon: '#icon-tab_me',
			active_icon: '#icon-tab_me_pre'
		}
	];

	this.instituteUser = {
		showBought: false
	};

	this.bindPhone = {
		// 登录方式，0：手机号，1：邮箱
		loginWay: [0]
	};

	// 小程序审核不过，所以发布的时候隐藏了行情以及公告等tab，审核通过，发布之后再放出来。
	// this.flagship = {
	// 	hideQuotation: true,
	// 	tabList: [100, 106],
	// }

	this.downloadFile = '/pages/download/index?url=';
}

// 获取分享配置
Bridge.prototype.getShareData = function () {
	return {
		title: '伊利股份IR企业号',
		desc: '关注伊利股份IR企业号',
		link: location.href,
		min_link: '/mobile/flagship/index?id=' + (isBuild ? 20902 : 314) + '&comein_channel=ylgf',
		img_url:
			'https://image.comein.cn/comein-files/img/2022-09-28/f916b54b-8598-49f1-b21c-cd3dc81afb73/f916b54b-8598-49f1-b21c-cd3dc81afb73.jpg',
		min_img_url:
			'https://image.comein.cn/comein-files/img/2022-09-28/f916b54b-8598-49f1-b21c-cd3dc81afb73/f916b54b-8598-49f1-b21c-cd3dc81afb73.jpg'
	};
};

// 页面跳转 亚厦股份小程序的首页是一个webview、页面跳转的时候需要打开一个新的webview、这时候左上角才会有后退按钮。
Bridge.prototype.navigateTo = function (obj) {
	let url = this.$router.resolve(obj).href;
	wx.miniProgram.navigateTo({
		url: '/pages/index/index?url=' + encodeURIComponent(url)
	});
};

export default Bridge;
